import React from 'react';
import { Box, styled, useTheme } from '@staffino/primitive-controls';

const StyledLabel = styled.label<{ size: number }>((props) => ({
  cursor: 'pointer',
  marginLeft: '2px',
  marginRight: '2px',
  maxHeight: '2.375rem',
  maxWidth: '2.375rem',
  width: props.size,
  height: 'auto',
}));

const RadioSvg = styled.svg<{ selected: boolean }>((props) => ({
  opacity: props.selected ? 1 : 0.35,
  '&:hover': {
    opacity: 1,
  },
  maxWidth: '2rem',
  maxHeight: '2rem',
}));

const HiddenRadio = styled.input({
  position: 'absolute',
  width: 0,
  height: 0,
  opacity: 0,
});

const CustomRadio = styled(Box)<{
  color: string;
  margin?: string;
  size?: number;
}>((props) => ({
  backgroundColor: props.color,
  borderRadius: '50%',
  padding: '0.1875rem',
  width: props.size,
  height: props.size,
}));

// TODO: replace svg with ::before ::after so we can animate that) take choice-radio-button as an example)
export default function RadioButton({
  score,
  width,
  selected,
  name,
  color,
  innerRef,
  onChange,
}) {
  const theme = useTheme();
  return (
    <>
      <HiddenRadio
        ref={innerRef}
        type="radio"
        name={name}
        defaultValue={score}
        id={`${name}.${score}`}
        onChange={() => onChange?.(score)}
      />

      <StyledLabel htmlFor={`${name}.${score}`} size={width}>
        <CustomRadio
          color={selected ? color || theme.colors.primaryBackground : '#fff'}
          // margin={selected ? '4px' : undefined}
        >
          <RadioSvg
            selected={selected}
            width="100%"
            stroke={selected ? '#fff' : '#a3b2bf'}
            fill="none"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="10" />
          </RadioSvg>
        </CustomRadio>
      </StyledLabel>
    </>
  );
}
